import { Component } from "react";
import { Modal } from "react-bootstrap";
import { popCancelBttn } from "../../assets";
import Button from "../Button";
import './GlobalSearchFeaturesPopUp.css'
import './PinToReadingListPopUp.css'
import ApiServices from "../../utils/apiServices";
import { snippetLongString } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
class RenameNotebookPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nName: '',
            nID: '',
            showSuccess: false,
            showPop: false,
            error: '',
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            alertMessageIsError: false
        }
    }
    componentDidMount() {
        this.setState({
            showPop: this.props.showModal,
            nName: this.props.nName,
            nID: this.props.nID
        });
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true,
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true,
            alertMessageIsError: true
        })
    }
    closeAlertMessage = () => {
        const { alertMessageIsError, showPop } = this.state;
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            showPop: alertMessageIsError ? showPop : false,
            alertMessageShowModal: false,
            alertMessageIsError: false,
        })
        if (!alertMessageIsError) {
            this.props.handleClose(false)
        }
    }
    handleOnClickView = async (nID, nName) => {
        let url = `/old_notebookView?notebookName=${encodeURIComponent(nName)}&notebookId=${nID}`;
        window.open(url, "_blank");
    }
    handleSuccessClose = (status) => {
        this.setState({
            showSuccess: status
        })
    }
    handleSave = async () => {
        if (this.handleValidation()) {
            let service = new ApiServices();
            let res = await service.updateNotebookName(this.state.nID, this.state.nName);
            if (res) {
                this.successAlertMessage('Notebook name saved successfully.');
            }
        }
    }
    handleInput = (e) => {
        e.target.value = snippetLongString(e.target.value);
        this.setState({
            nName: e.target.value
        })
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        let notebooklist = this.props.apiResponse.filter(x => x.notebooklist_id !== this.state.nID).map(data => data.notebooklist_name.toLowerCase())
        if (this.state.nName.length <= 0) {
            formIsValid = false;
            errors["pinNotebookList"] = `Please enter a valid name to proceed.`;
        }
        if (notebooklist.includes(this.state.nName.toLowerCase())) {
            formIsValid = false;
            errors["pinNotebookList"] = `You already have a notebook with entered title. Please enter a new name.`;
        }
        this.setState({ error: errors });
        return formIsValid;
    }
    render() {
        const { alertMessageModelColor, alertMessageContent, alertMessageShowModal } = this.state;
        if (this.props.width <= 1000) {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        className="z-index-rename"
                        backdropClassName="z-index-rename-backdrop"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left", padding: "0.5rem 0" }}>
                                    <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Notebook
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="reading-list-view-wrapper">
                                        <tr><th>Notebook Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "60%" }}><input type="text" value={this.state.nName} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["pinNotebookList"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}><span onClick={e => this.handleOnClickView(this.props.nID, this.props.nName)} title="View" style={{ marginRight: "5px" }} className="reading-list-action-text">View</span><span className="action-items-separate-divider"></span><span title="Save" onClick={e => this.handleSave()} className="reading-list-action-text">Save</span></td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="reading-list-button-tablet-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
        else {
            return (
                <>
                    <Modal
                        show={this.state.showPop}
                        size="lg md sm xs"
                        centered
                        aria-labelledby="contained-modal-title-vcenter"
                        dialogClassName="popup-transition"
                        className="z-index-rename"
                        backdropClassName="z-index-rename-backdrop"
                        scrollable={true}
                    >
                        <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                            <div className="popup-cancel-btn-wrapper">
                                <img
                                    src={popCancelBttn}
                                    alt=""
                                    onClick={e => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }}
                                />
                            </div>
                            <div>
                                <Modal.Header className="gsfModalHeader" style={{ justifyContent: "left" }}>
                                    <div style={{ textAlign: "center", width: "30%", paddingTop: "1%" }}>
                                        <Modal.Title>
                                            <div className="actionItem-headerPart">
                                                Rename Notebook
                                            </div>
                                        </Modal.Title>
                                    </div>
                                </Modal.Header>
                                <Modal.Body scrollable={true} style={{ minHeight: "25vh" }}>
                                    <table className="reading-list-view-wrapper">
                                        <tr><th>Notebook Name</th><th style={{ textAlign: "center" }}>Actions</th></tr>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "60%" }}><input type="text" value={this.state.nName} onChange={this.handleInput} /><br /><div className="errorInvalidName">{this.state.error["pinNotebookList"]}</div></td>
                                                <td style={{ display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", width: "100%" }}><span onClick={e => this.handleOnClickView(this.props.nID, this.props.nName)} title="View" style={{ marginRight: "5px" }} className="reading-list-action-text">View</span><span className="action-items-separate-divider"></span><span title="Save" onClick={e => this.handleSave()} className="reading-list-action-text">Save</span></td>
                                            </tr>
                                            <span className="length-info">Name with a maximum of 100 characters.</span>
                                        </tbody>
                                    </table>
                                </Modal.Body>
                                <div className="reading-list-button-wrapper">
                                    <Button text="Cancel" customColor="#000000" action={() => {
                                        this.setState({ showPop: false });
                                        this.props.handleClose(false);
                                    }} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                </>
            )
        }
    }
}
export default RenameNotebookPopup;